import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [
//drink-machine
{
  path: "/dy_group_buy",
  component: function component() {
    return import("../../../views/dy_group_buy/index.vue");
  },
  name: "dy_group_buy",
  meta: {
    title: "抖音团购",
    foot: true
  }
}, {
  path: "/dy_group_buy_search",
  component: function component() {
    return import("../../../views/dy_group_buy/search.vue");
  },
  name: "dy_group_buy_search",
  meta: {
    title: "搜索",
    foot: true
  }
}, {
  path: "/dy_group_buy_details/:id/:city_code?",
  component: function component() {
    return import("../../../views/dy_group_buy/details.vue");
  },
  name: "dy_group_buy_details",
  meta: {
    title: "商品详情",
    foot: true
  }
}, {
  path: "/dy_group_buy__order/:status?",
  name: "DyOrder",
  component: function component() {
    return import("../../../views/dy_group_buy/order.vue");
  },
  meta: {
    title: "抖音团购",
    foot: true
  }
}];